import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {useProductsSearch} from "@/hooks/useProductsSearch";
import {useRoute} from "vue-router/dist/vue-router";
import ProductList from "@/components/products/product-list.vue";
import {watch, ref} from "vue";
import ProductsWithFilter from "@/components/common/products-with-filter.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchView',
  setup(__props) {

const router = useRoute();
const page = ref(1);
const searchString = ref(router.params.query as string);
let {isLoading, data: products, error} = useProductsSearch(searchString, page, [searchString, page])
watch(() => router.params.query, ()=>searchString.value = router.params.query as string, {deep: true})

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(ProductsWithFilter, {
        products: _unref(products),
        "is-loading": _unref(isLoading),
        title: "Search products"
      }, null, 8, ["products", "is-loading"])
    ]),
    _: 1
  }))
}
}

})